/** Réinitialise le zoom iOS Safari après focus sur un input (souvent < 16px). */
export function resetMobileZoom() {
  if (typeof window === 'undefined') return;

  const active = document.activeElement;
  if (active && typeof active.blur === 'function') {
    active.blur();
  }

  const meta = document.querySelector('meta[name="viewport"]');
  const defaultContent = 'width=device-width, initial-scale=1';

  if (meta) {
    const original = meta.getAttribute('content') || defaultContent;
    meta.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
    );
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        meta.setAttribute('content', original);
        window.scrollTo(0, 0);
      });
    });
  } else {
    window.scrollTo(0, 0);
  }
}
